import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useHttpTaxManagerAppHeaders } from "../utils/useHttpTaxManagerAppHeaders";
import { BASE_API_URL, HttpError } from "../utils/useTaxManagerAppQueryClient";
import type { SubscriptionDto } from "./SubscriptionDto";

// This hook runs in ViewWrapper, i.e. BEFORE the tenant workspace is resolved
// and therefore outside WorkspaceIdProvider: the id comes in as a parameter
// (from useTenantWorkspace) and while it is undefined the query stays disabled,
// covered by ViewWrapper's loader.
export function useGetSubscriptions(workspaceId: string | undefined) {
    const { t } = useTranslation();
    const headers = useHttpTaxManagerAppHeaders();

    const query = useQuery<SubscriptionDto[]>({
        queryKey: ["useGetSubscriptions", workspaceId],
        queryFn: async () => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/subscriptions`,
                { headers },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },
        enabled: !!workspaceId,
        initialData: [],
        placeholderData: () => [],
        meta: {
            resourceName: t("errors.resourceName.subscriptions"),
        },
    });

    return query;
}
